import React from "react";

interface Props {
  onClick: () => void;
}

export default function ActionButtonDelCertificate(props: Props) {
  return (
    // eslint-disable-next-line
    <a
      className="pointer text-danger ml-1 mr-1"
      title="Xóa chứng thư số của USB token"
      onClick={props.onClick}
    >
      <i className="fas fa-ban fa-lg" />
    </a>
  );
}
